import React from "react";

const InfoItem = ({ iconClass, header, subheader, className = "" }) => {
  return (
    <div
      className={`col-xl-6 col-12 custom-column-2 d-flex align-items-center ${className}`}
      style={{ borderWidth: "0px", margin: "0px" }}
    >
      <i
        className="bi bi-check-circle"
        style={{ fontSize: "25px", paddingRight: "20px", color: "#221AFB" }}
      ></i>
      <div>
        <div className="column-header-2">{header}</div>
        <div className="column-subheader-2">{subheader}</div>
      </div>
    </div>
  );
};

export default InfoItem;
